import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-12">
        <div className="max-w-5xl mx-auto flex flex-col items-center gap-4 text-center">
          <a
            href="https://www.melangenaturel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
          >
            <img
              src="/images/logo-melangenaturel.webp"
              alt="MÉLANGE NATUREL"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </a>
          <p className="text-foreground-500 text-xs md:text-sm">
            {t('footer_visit')}
            {i18n.language === 'zh' ? <br /> : ' '}
            <a
              href="https://www.melangenaturel.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors"
            >
              https://www.melangenaturel.com
            </a>
          </p>
          <p className="text-foreground-500 text-xs md:text-sm">
            {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}